import { all, call, getContext, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import type { NotifPrefs } from '../domain/notif-prefs.model';
import type { NotificationPreferencesGateway } from '../infrastructure/notification-preferences.gateway';
import { loadRequested, prefChanged } from './notification-preferences.actions';
import { selectPrefs } from './notification-preferences.selectors';
import { notificationPreferencesActions } from './notification-preferences.slice';

/** WORKER: hydrate prefs from storage on mount (the gateway falls back to defaults). */
function* loadWorker(action: ReturnType<typeof loadRequested>) {
  const gateway: NotificationPreferencesGateway = yield getContext('notificationPreferencesGateway');
  const prefs = (yield call(gateway.load, action.payload)) as NotifPrefs;
  yield put(notificationPreferencesActions.loaded(prefs));
}

/**
 * WORKER: apply one toggle (optimistic reducer) then persist the full prefs.
 * `takeEvery` so rapid toggles each persist; each save reads the post-toggle
 * state so the last write reflects every change.
 */
function* changeWorker(action: ReturnType<typeof prefChanged>) {
  const { userId, key, value } = action.payload;
  yield put(notificationPreferencesActions.toggled({ key, value }));
  const prefs = (yield select(selectPrefs)) as NotifPrefs;
  const gateway: NotificationPreferencesGateway = yield getContext('notificationPreferencesGateway');
  yield call(gateway.save, userId, prefs);
}

/** WATCHERS. */
export function* notificationPreferencesSaga() {
  yield all([
    takeLatest(loadRequested.type, loadWorker),
    takeEvery(prefChanged.type, changeWorker),
  ]);
}
